import React, {Component, Fragment} from 'react';
import * as invoices from 'invoices/actions/invoices';
import {Button} from 'reactstrap';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import {connect} from 'react-redux';

@connect(
    state => (
        {
            invoices: state.invoices,
            auth: state.apa,
        }
    ),
    dispatch => (
        {
            fetchInvoices: () => dispatch(invoices.fetchInvoices())
        }
    )
)
export default class DeleteInvoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        }
    }

    @autobind
    toggleModal() {
        this.setState(
            {
                ...this.state,
                isModalOpen: !this.state.isModalOpen
            }
        );
    }

    @autobind
    confirm() {
        const headers = {'Content-Type': 'application/json'};
        headers['Authorization'] = `Token ${this.props.auth.token}`;
        fetch(
            `/api/invoices/${this.props.invoice.id}/`,
            {headers, method: 'DELETE'}
        ).then(
            () => {
                this.toggleModal();
                this.props.fetchInvoices()
            }

        );
    }

    render() {
        return (
            <Fragment>
                <Button onClick={this.toggleModal} color='danger'>
                    <i className='fa fa-times'> </i>
                </Button>
                <Dialog
                    toggle={this.toggleModal}
                    confirm={this.confirm}
                    isOpen={this.state.isModalOpen}
                    title={'Rechnung löschen'}
                >
                    Sind Sie Sicher?
                </Dialog>
            </Fragment>
        )
    }

}